import { render, staticRenderFns } from "./TotalGoal.vue?vue&type=template&id=25d8e636&"
import script from "./TotalGoal.vue?vue&type=script&lang=js&"
export * from "./TotalGoal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports